export const TaskTypes = {
    RECEIVE_TASK_DATA: 'RECEIVE_TASK_DATA',
    ADD_TASK: 'ADD_TASK',
    SET_TASK: 'SET_TASK',
    REMOVE_TASK: 'REMOVE_TASK',
    TOGGLE_TASK: 'TOGGLE_TASK',
    CLICK_TASK: 'CLICK_TASK',
    SET_TASK_PRIORITY: 'SET_TASK_PRIORITY',
    SET_TASK_DUE_DATE: 'SET_TASK_DUE_DATE',
}